export default "__VITE_ASSET__DQ7HaE$C__"